import { useEffect, useState } from 'react'

export const useClickOutside = (
  ref: any,
  handlePopup: (b: boolean) => void,
) => {
  const [clickedOutside, setClickedOutside] = useState(false)
  const handleClickInside = () => setClickedOutside(false)

  const handleClickOutside = (e: any) => {
    !ref.current.contains(e.target) && setClickedOutside(true)
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  })

  useEffect(() => {
    clickedOutside && handlePopup(false)
  }, [clickedOutside])

  return [handleClickInside]
}
